var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"mode":"out-in","name":"overlay"}},[_c('div',{staticClass:"full-screen-loader-container"},[_c('div',{staticClass:"full-page-overlay"}),_c('div',{staticClass:"full-screen-loader"},[_c('div',{staticClass:"spinner"},[_c('div',{style:({ boxShadow: `0 4px 0 0 ${_vm.color}` })})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }